import { ImUser } from 'Src/ng2/shared/services/im-models/im-user';
import { IUser } from '../../../ng2/shared/typings/interfaces/user.interface';

// TODO: is this route used anywhere? If not, we should remove it (CM).
angular.module('nv.routes.main').config(function($stateProvider) {
  $stateProvider.state('main.my-supports', {
    url: '/my-supports',
    controller: function mySupportsRedirectController(currentUser: IUser, $state, ImUser: ImUser) {
      if (ImUser.isSchoolUser(currentUser)) {
        const schoolId = ImUser.getPrimarySchool(currentUser);
        if (schoolId) {
          $state.go('main.school.my-supports', { schoolId });
        } else {
          $state.go('main.home');
        }
      } else {
        // TODO: how to handle cluster users?
        $state.go('main.cluster');
      }
    },
  });
});
